/**
 * @fileoverview A failure inside the image conversion pipeline itself: a canvas
 * that returned no blob, a 2d context the browser would not create. The message
 * is operator copy for Sentry; `isPlumbingError` deny-lists it so no display site
 * shows it, and `describeImageUploadRejection` falls back to its own copy.
 *
 * Standalone like `heicDecodeError.ts`: `apiErrors.ts` consumes it and must not
 * pull in the image upload graph.
 */
export class ImageConversionError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'ImageConversionError'
  }
}

export function isImageConversionError(error: unknown): error is ImageConversionError {
  return error instanceof ImageConversionError
}
